var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-backdrop-custom"},[_c('div',{staticClass:"modal-inside"},[_vm._t("body",function(){return [_vm._v(" This is the default body! ")]}),_c('footer',{staticClass:"modal-footer-custom"},[_vm._t("footer")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }